// extracted by mini-css-extract-plugin
export var fadeInOut = "_3d-3";
export var icon = "_3d-4";
export var savedIndicator = "_3d-2";
export var savingIndicator = "_3d-0";
export var spin = "_3d-1";